"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("../errors");
const api_1 = require("../api");
const shared_1 = require("../shared");
const config_1 = require("../config");
const fetchReportCollection = (reportParams_1, ...args_1) => __awaiter(void 0, [reportParams_1, ...args_1], void 0, function* (reportParams, requestConfig = (0, config_1.getRequestConfig)()) {
    const resourcePath = (0, shared_1.getResourcePath)(reportParams);
    const path = `${resourcePath}/report-collections/${reportParams.id}`;
    try {
        return yield (0, api_1.get)({ path, config: requestConfig });
    }
    catch (err) {
        (0, shared_1.handleError)(err, errors_1.ReportFetchError);
    }
});
exports.default = fetchReportCollection;
